<template>
  <q-layout view="lHh Lpr lFf">
    <q-header elevated class="glossy">
      <q-toolbar>
        <!-- ☰ Drawer toggle (top-left) -->
        <q-btn
          flat
          dense
          round
          icon="menu"
          aria-label="Menu"
          @click="leftDrawerOpen = !leftDrawerOpen"
          class="q-mr-sm"
        />

        <!-- App title -->
        <q-toolbar-title> SoftSmartTech </q-toolbar-title>

        <!-- 👤 Profile menu (top-right) -->
        <q-btn flat dense no-wrap>
          <q-icon name="account_circle" class="q-mr-xs" />
          <span>Profile</span>

          <q-menu anchor="bottom right" self="top right">
            <q-list style="min-width: 150px">
              <q-item clickable v-ripple @click="onChangePassword">
                <q-item-section>Change Password</q-item-section>
              </q-item>
              <q-item clickable v-ripple @click="onSettings">
                <q-item-section>Settings</q-item-section>
              </q-item>
              <q-item clickable v-ripple @click="onHelp">
                <q-item-section>Help</q-item-section>
              </q-item>
              <q-separator />
              <q-item clickable v-ripple @click="logout">
                <q-item-section class="text-negative">Logout</q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>
      </q-toolbar>
    </q-header>

    <q-drawer
      v-model="leftDrawerOpen"
      show-if-above
      bordered
      class="bg-blue-grey-1"
    >
      <q-list>
        <!-- Simple drawer header (no smart_toy icon) -->
        <q-separator size="2px" color="grey-4" class="q-mt-none" />
        <q-item elevated class="glossy bg-primary">
          <q-item-section >
            <q-item-label class="text-subtitle1 text-white" >
              AI Assistant by SoftSmartTech
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-separator size="2px" color="grey-4" class="q-mt-none" />

        <!-- Nav items -->
        <q-item to="/email" clickable v-ripple>
          <q-item-section avatar>
            <q-icon name="chat" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Email Assistant</q-item-label>
            <q-item-label caption
              >Create emails from bullet points</q-item-label
            >
          </q-item-section>
        </q-item>

        <q-item v-if="hasPermissions" to="/document" clickable v-ripple>
          <q-item-section avatar>
            <q-icon name="description" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Document Generator</q-item-label>
            <q-item-label caption>generate recommendation</q-item-label>
          </q-item-section>
        </q-item>

        <q-item v-if="hasPermissions" clickable to="/iam/users">
          <q-item-section avatar>
            <q-icon name="manage_accounts" />
          </q-item-section>
          <q-item-section>User Management</q-item-section>
        </q-item>

        <q-item v-if="hasPermissions" clickable to="/iam/groups">
          <q-item-section avatar><q-icon name="security" /></q-item-section>
          <q-item-section>Groups & Permissions</q-item-section>
        </q-item>

        <!-- Admin Dashboard (ONLY for admins) -->
        <q-separator v-if="isAdmin" class="q-my-md" />

        <q-item
          v-if="isAdmin"
          clickable
          to="/admin"
          active-class="bg-primary text-white"
        >
          <q-item-section avatar>
            <q-icon name="admin_panel_settings" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Admin Dashboard</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-drawer>

    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';

export default {
  name: 'MainLayout',

  setup() {
    const leftDrawerOpen = ref(true);
    const router = useRouter();

    const me = computed(() => {
      try {
        return JSON.parse(localStorage.getItem('me') || '{}');
      } catch {
        return {};
      }
    });

    const isAdmin = computed(() => {
      const user = me.value;
      return (
        user?.groups?.includes('Admin') ||
        user?.groups?.includes('HR Personnel') ||
        user?.is_staff ||
        false
      );
    });

    const hasPermissions = computed(() => {
      const groups = me.value.groups || [];
      const permissions = me.value.permissions || [];
      return groups.length > 0 || permissions.length > 0;
    });

    const logout = () => {
      localStorage.removeItem('access');
      localStorage.removeItem('refresh');
      router.push('/login');
    };

    const onChangePassword = () => {
      router.push('/change-password');
    };

    const onSettings = () => {
      // TODO: navigate to a settings page when you add it
      console.log('Settings clicked');
    };

    const onHelp = () => {
      // TODO: show a help dialog/page when you add it
      console.log('Help clicked');
    };

    return {
      leftDrawerOpen,
      logout,
      onChangePassword,
      onSettings,
      onHelp,
      hasPermissions,
      isAdmin,
    };
  },
};
</script>

<style scoped>
/* Mobile responsiveness */
@media (max-width: 768px) {
  .q-toolbar-title {
    font-size: 1rem;
  }

  .q-drawer {
    width: 280px;
  }
}

@media (max-width: 600px) {
  .q-toolbar .q-btn span {
    display: none;
  }

  .q-toolbar-title {
    font-size: 0.9rem;
  }
}
</style>
